<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="tonal"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="500">
        <p>النص</p>
        <p>{{ item.text }}</p>
        <p>المستلمون</p>
        <v-list>
          <v-list-item v-for="x in item.users" :key="x.id">
            {{ x.fullname }} | {{ x.email }} |
            {{ x.pivot.isRead == 1 ? "تمت القراءة" : "" }}
          </v-list-item>
        </v-list>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["item", "users", "iconName"],
  data() {
    return {
      isActive: false,
      formData: {
        users: null,
        text: "",
      },
    };
  },
  methods: {
    close() {
      this.isActive = false;
    },
  },
  computed: {
    title() {
      return "معاينة الرسالة";
    },
  },
};
</script>
